var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoZaldivar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 910.02 355.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-8 {\n        fill: #575756;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 168.21,
    y1: 127.13,
    x2: 267.96,
    y2: 127.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d51224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#d61d21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#dc3b1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#e46c0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ae00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 168.21,
    y1: 211.85,
    x2: 291.28,
    y2: 211.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00718b",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78c7c9",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 110.75,
    y1: 192.73,
    x2: 210.51,
    y2: 192.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c7c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00718b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 267.96,
    y1: 228.52,
    x2: 344.6,
    y2: 228.52,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 153.05,
    y1: 146.24,
    x2: 229.04,
    y2: 146.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ae00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ed9f03",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#db391a",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d51224",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 76.41,
    y1: 238.03,
    x2: 153.04,
    y2: 238.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#78c7c9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#0b7991",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00718b",
    stopOpacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 910.02,
    height: 355.64
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 362.81,
    y: 182.55,
    width: 470.8,
    height: 2.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m386.19,227.61h-3.63l-3.01-7.7h-10.97l-2.99,7.7h-3.61l10.4-26.61h3.4l10.41,26.61Zm-7.86-10.9l-4.28-10.83-4.22,10.83h8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m410,227.61h-3.16l-12.16-19.93v19.93h-3.36v-26.61h3.17l12.2,19.94v-19.94h3.31v26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m435.1,204.28h-8.13v23.33h-3.36v-23.33h-8.11v-3.28h19.59v3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m460.03,214.3c0,3.93-.71,6.94-2.13,9.08-2.01,3.05-4.9,4.58-8.65,4.58s-6.66-1.53-8.67-4.58c-1.42-2.13-2.12-5.15-2.12-9.08s.71-6.93,2.12-9.08c2.04-3.04,4.93-4.56,8.67-4.56s6.64,1.51,8.65,4.56c1.42,2.14,2.13,5.17,2.13,9.08Zm-3.36,0c0-3.27-.53-5.69-1.6-7.27-1.35-2.04-3.3-3.05-5.83-3.05s-4.49,1.01-5.85,3.05c-1.06,1.58-1.6,4-1.6,7.27s.54,5.69,1.6,7.29c1.36,2.04,3.3,3.05,5.85,3.05s4.47-1.01,5.83-3.05c1.07-1.59,1.6-4.03,1.6-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m482.67,204.28h-13.62v8.04h12.21v3.09h-12.21v12.2h-3.31v-26.61h16.93v3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m508.09,227.61h-3.62l-3.02-7.7h-10.98l-2.97,7.7h-3.6l10.4-26.61h3.38l10.41,26.61Zm-7.85-10.9l-4.27-10.83-4.24,10.83h8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m531.38,213.12l-.04,14.49h-3.01v-2.74c-.74,1.17-1.63,2-2.7,2.48-.95.41-2.16.61-3.67.61-3.66,0-6.41-1.43-8.26-4.28-1.57-2.42-2.34-5.54-2.34-9.38s.8-7.02,2.38-9.41c1.88-2.82,4.66-4.23,8.37-4.23,1.89,0,3.54.43,4.97,1.29,1.18.7,2.46,1.88,3.8,3.5l-2.55,2.11c-1.01-1.23-1.9-2.09-2.67-2.61-1.01-.65-2.19-.98-3.55-.98-4.92,0-7.38,3.45-7.38,10.32s2.41,10.33,7.24,10.33c2.17,0,3.75-.88,4.77-2.67.84-1.42,1.26-3.3,1.26-5.64h-6.61v-3.2h10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m560.36,227.61h-3.61l-3.01-7.7h-10.98l-2.98,7.7h-3.61l10.4-26.61h3.4l10.4,26.61Zm-7.85-10.9l-4.28-10.83-4.23,10.83h8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m584.53,219.87c0,2.48-.99,4.5-2.97,6.03-1.81,1.36-4,2.06-6.6,2.06-6.09,0-9.6-2.77-10.56-8.28l3.3-.57c.36,2.01,1.16,3.46,2.41,4.35,1.12.78,2.75,1.18,4.85,1.18,1.65,0,3.05-.37,4.19-1.1,1.35-.89,2.03-2.11,2.03-3.66,0-1.93-1.37-3.33-4.08-4.19-2.51-.72-5.01-1.44-7.55-2.18-2.72-1.17-4.07-3.11-4.07-5.82,0-2.3.91-4.06,2.74-5.31,1.6-1.08,3.6-1.65,5.99-1.65s4.41.46,5.91,1.4c1.51.92,2.78,2.46,3.82,4.64l-3.05,1.4c-.78-1.58-1.63-2.66-2.56-3.25-.95-.58-2.31-.87-4.12-.87-3.58,0-5.37,1.2-5.37,3.63,0,1.55,1.36,2.71,4.08,3.5,4.7,1.36,7.2,2.15,7.55,2.32,2.71,1.35,4.07,3.47,4.07,6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m607.44,204.28h-8.12v23.33h-3.36v-23.33h-8.12v-3.28h19.6v3.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m631.69,227.61h-3.62l-3.02-7.7h-10.97l-2.98,7.7h-3.62l10.4-26.61h3.4l10.41,26.61Zm-7.86-10.9l-4.27-10.83-4.23,10.83h8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m671.87,227.61h-3.36v-17.15l-6.39,17.15h-2.93l-6.38-17.04v17.04h-3.36v-26.61h2.78l8.43,21.61,8.04-21.61h3.16v26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m683.23,227.61h-3.46v-26.61h3.46v26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m709.73,227.61h-3.17l-12.17-19.93v19.93h-3.36v-26.61h3.17l12.2,19.94v-19.94h3.32v26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m734.65,227.61h-17.31v-26.61h17.31v3.28h-13.99v8.07h12.23v3.06h-12.23v8.92h13.99v3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m760.43,227.61h-3.75l-5.72-9.8c-.73-1.23-1.68-1.86-2.85-1.86h-3.48v11.65h-3.28v-26.61h9.26c2.63,0,4.72.57,6.25,1.72,1.7,1.28,2.55,3.21,2.55,5.75,0,1.86-.55,3.49-1.65,4.88-1.12,1.41-2.58,2.25-4.4,2.57.18.2.41.52.72.95l6.33,10.74Zm-4.28-19.14c0-2.82-1.84-4.22-5.53-4.22h-5.99v8.84h6.11c3.6,0,5.4-1.53,5.4-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m788.26,227.61h-3.63l-3.01-7.7h-10.98l-2.97,7.7h-3.63l10.42-26.61h3.39l10.41,26.61Zm-7.85-10.9l-4.27-10.83-4.23,10.83h8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m809.22,227.61h-15.74v-26.61h3.31v23.34h12.43v3.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m833.55,219.87c0,2.48-.99,4.5-2.98,6.03-1.79,1.36-3.99,2.06-6.6,2.06-6.06,0-9.58-2.77-10.56-8.28l3.32-.57c.35,2.01,1.16,3.46,2.4,4.35,1.11.78,2.73,1.18,4.83,1.18,1.67,0,3.06-.37,4.21-1.1,1.34-.89,2.01-2.11,2.01-3.66,0-1.93-1.36-3.33-4.07-4.19-2.54-.72-5.04-1.44-7.55-2.18-2.72-1.17-4.09-3.11-4.09-5.82,0-2.3.93-4.06,2.76-5.31,1.61-1.08,3.59-1.65,5.99-1.65s4.4.46,5.9,1.4c1.49.92,2.76,2.46,3.81,4.64l-3.05,1.4c-.76-1.58-1.62-2.66-2.55-3.25-.94-.58-2.32-.87-4.11-.87-3.59,0-5.39,1.2-5.39,3.63,0,1.55,1.37,2.71,4.07,3.5,4.71,1.36,7.23,2.15,7.57,2.32,2.71,1.35,4.07,3.47,4.07,6.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m341.15,249.16h0s-49.87-71.34-49.87-71.34l-23.31-33.34-41.83-59.84h0c-3.43-4.93-9.11-8.17-15.56-8.21h-.13c-6.45.05-12.14,3.28-15.56,8.21h0l-26.67,38.15h0l-15.16,21.68h0l-42.3,60.5-30.88,44.18h0c-6.05,8.65-3.94,20.56,4.71,26.61,8.64,6.05,20.55,3.94,26.6-4.71h0s41.87-59.89,41.87-59.89l15.16,21.69,26.67,38.15h0c3.42,4.93,9.11,8.17,15.56,8.22h.13c6.45-.04,12.14-3.29,15.56-8.22h0l41.83-59.83,41.87,59.88s0,0,0,0c6.04,8.65,17.95,10.76,26.6,4.71,8.65-6.04,10.76-17.96,4.71-26.6Zm-130.26-23.05l-.38.56h0s-34.15-48.85-34.15-48.85l34.15-48.85h0l.38.55,33.76,48.3-33.76,48.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m187.09,114.65c8.97,0,16.86,4.58,21.49,11.52.65.97,1.92,2.8,1.92,2.8l.38.55,33.76,48.3,23.31-33.34-41.83-59.84h0c-3.43-4.93-9.11-8.17-15.56-8.21h-.13c-6.45.05-12.14,3.28-15.56,8.21h0l-26.67,38.15h0c4.72-5,11.46-8.14,18.88-8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m187.09,240.99c8.97,0,16.86-4.58,21.49-11.52.65-.97,1.92-2.8,1.92-2.8l.38-.56,57.07-81.64,23.31,33.34-65.14,93.18h0c-3.43,4.93-9.11,8.17-15.56,8.22h-.13c-6.45-.04-12.14-3.29-15.56-8.22h0l-26.67-38.15h0c4.72,5.01,11.46,8.14,18.88,8.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m168.21,232.85h0c4.72,5.01,11.46,8.14,18.88,8.14,8.97,0,16.86-4.58,21.49-11.52.65-.97,1.92-2.8,1.92-2.8h0s-41.83-59.84-41.83-59.84h0l-15.63-22.36-42.3,60.5c4.72-5,11.46-8.13,18.88-8.13,8.3,0,15.67,3.92,20.39,9.99l3.03,4.33,15.16,21.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m341.15,249.16h0s-49.87-71.34-49.87-71.34l-23.31,33.34,41.87,59.88h0s0,0,0,0c6.04,8.65,17.95,10.76,26.6,4.71,8.65-6.04,10.76-17.96,4.71-26.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m210.51,128.97h0s-1.28-1.83-1.92-2.8c-4.64-6.94-12.52-11.52-21.49-11.52-7.42,0-14.16,3.14-18.88,8.14h0l-15.16,21.69,23.31,33.34,34.15-48.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m129.63,196.84c-7.42,0-14.16,3.13-18.88,8.13h0l-30.88,44.18h0c-6.05,8.65-3.94,20.56,4.71,26.61,8.64,6.05,20.55,3.94,26.6-4.71h0s41.87-59.89,41.87-59.89l-3.03-4.33c-4.72-6.08-12.09-9.99-20.39-9.99Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m390.17,168.55h-30.41v-4.29l23.22-33.63h-21.06v-5.32h28.25v4.52l-23.1,33.39h23.1v5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m434.15,168.55h-5.88l-4.9-12.52h-17.83l-4.83,12.52h-5.88l16.91-43.24h5.5l16.91,43.24Zm-12.77-17.73l-6.92-17.58-6.87,17.58h13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m465.61,168.55h-25.58v-43.24h5.4v37.9h20.18v5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m503.33,146.91c0,4.19-.15,7.36-.49,9.6-.69,4.75-2.7,8.03-6,9.85-2.56,1.45-6.46,2.18-11.7,2.18h-13.32v-43.24h13.32c5.25,0,9.14.71,11.7,2.16,3.3,1.81,5.31,5.1,6,9.85.34,2.19.49,5.39.49,9.59Zm-5.45,0c0-3.92-.12-6.9-.43-8.92-.45-3.22-1.88-5.35-4.26-6.39-1.49-.64-4.17-.98-8.06-.98h-7.87v32.53h7.87c3.88,0,6.56-.32,8.06-.93,2.38-1.03,3.81-3.16,4.26-6.38.3-2.07.43-5.05.43-8.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m522.43,111.49l-6.5,9.03h-4.54l5.21-9.03h5.83Zm-4.1,57.05h-5.63v-43.24h5.63v43.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m558.78,125.31l-14.17,43.24h-4.9l-14.18-43.24h5.7l10.89,33.31,10.91-33.31h5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m596.57,168.55h-5.89l-4.89-12.52h-17.85l-4.82,12.52h-5.89l16.91-43.24h5.52l16.91,43.24Zm-12.76-17.73l-6.94-17.58-6.86,17.58h13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m633.49,168.55h-6.07l-9.29-15.92c-1.22-2.03-2.76-3.04-4.65-3.04h-5.65v18.96h-5.32v-43.24h15.06c4.29,0,7.66.91,10.16,2.78,2.75,2.12,4.14,5.23,4.14,9.36,0,3.01-.9,5.65-2.7,7.92-1.8,2.28-4.18,3.65-7.16,4.15.3.34.69.85,1.18,1.55l10.28,17.47Zm-6.94-31.1c0-4.59-3-6.88-8.97-6.88h-9.74v14.37h9.91c5.87,0,8.8-2.49,8.8-7.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZaldivar);
export default __webpack_public_path__ + "static/media/logo-zaldivar.a1084c500e0df288af0c8b26d169e512.svg";
export { ForwardRef as ReactComponent };